<script lang="ts">
import FicheDocumentList from '@/generated/fiches/FicheDocumentList.vue';
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    extends: FicheDocumentList,
    methods: {
        isDisplayed(value: string): boolean {
            return true;
        }
    }
})

</script>
